'use client';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { CookiePreferencesModal } from '@/components/CookiePreferencesModal';

import { WEBAPP_URL } from '@/constants/http-constants';

import { addUtmParams } from '@/helpers/utm-helper';

import { IconMenu24 } from '@cineamo/ui/src/icons/ic-menu';

import { Link } from '@/i18n/routing';
import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

const BurgerMenu = () => {
    const domainConfiguration = useDomainConfiguration();
    const t = useTranslations();
    const [cookiePreferencesModalIsOpen, setCookiePreferencesModalIsOpen] = useState(false);

    const cinema = domainConfiguration.cinema;
    const websiteConfiguration = cinema?._embedded?.cinemaConfiguration?.websiteConfiguration;
    const cinemaHasCustomImprint = (websiteConfiguration?.imprints?.length ?? 0) > 0 || !!websiteConfiguration?.imprint;
    const cinemaHasTermsAndConditions =
        !!cinema?._embedded?.cinemaConfiguration?.websiteConfiguration?.termsAndConditionsUrl;
    const linkClass = 'py-8 px-16 text-left text-darkBlue text-body-14 hover:bg-gray-light whitespace-nowrap';
    return (
        <div className="absolute right-9 lg:right-16 top-1/2 transform -translate-y-1/2">
            {cookiePreferencesModalIsOpen && (
                <CookiePreferencesModal
                    domainConfiguration={domainConfiguration}
                    modalIsOpen={cookiePreferencesModalIsOpen}
                    setModalIsOpen={setCookiePreferencesModalIsOpen}
                />
            )}
            <Popover className="relative">
                <PopoverButton>
                    <IconMenu24 />
                </PopoverButton>
                <PopoverPanel
                    anchor={{ to: 'bottom end', gap: '8px' }}
                    className="bg-white rounded-8 overflow-hidden z-[110]">
                    <ul className="flex flex-col divide-y divide-white/50">
                        <Link
                            className={linkClass}
                            href={addUtmParams(`${WEBAPP_URL}/data-protection`, {
                                utmSource: 'cinema_website',
                                utmContent: 'booking-burger_menu-data_protection',
                                utmCampaign: `cinema_${domainConfiguration.cinema.id}-${domainConfiguration.cinema.name}`,
                                utmMedium: 'website'
                            })}>
                            {t('footer.data-protection')}
                        </Link>
                        <Link
                            className={linkClass}
                            href={
                                cinemaHasCustomImprint
                                    ? '/imprint'
                                    : addUtmParams(`${WEBAPP_URL}/imprint`, {
                                          utmSource: 'cinema_website',
                                          utmContent: 'booking-burger_menu-imprint',
                                          utmCampaign: `cinema_${domainConfiguration.cinema.id}-${domainConfiguration.cinema.name}`,
                                          utmMedium: 'website'
                                      })
                            }>
                            {t('footer.imprint')}
                        </Link>
                        <Link
                            className={linkClass}
                            href={'/accessibility-statement'}>
                            {t('footer.accessibility-statement')}
                        </Link>
                        {cinemaHasTermsAndConditions && (
                            <Link
                                className={linkClass}
                                href={
                                    cinema?._embedded?.cinemaConfiguration?.websiteConfiguration
                                        ?.termsAndConditionsUrl ?? ''
                                }>
                                {t('footer.terms-and-conditions')}
                            </Link>
                        )}
                        <button
                            className={linkClass}
                            onClick={() => setCookiePreferencesModalIsOpen(true)}>
                            {t('footer.data-protection-settings')}
                        </button>
                    </ul>
                </PopoverPanel>
            </Popover>
        </div>
    );
};

export default BurgerMenu;
